import { useEffect } from 'react';
import { BrandLogo, ProductMark, PRODUCT_NAME } from './Brand.jsx';
import ExternalLink from './ExternalLink.jsx';
import { HeaderAccent } from './TopBar.jsx';
import BrandFooter from './BrandFooter.jsx';
import { BRAND } from '../lib/brand.js';
import { ensureNoReferrer } from '../lib/watch-fragment.js';

/**
 * The reviewer decision view's minimal shell (Access reviews spec 13.2): the onGuard lockup, the customer's name and the
 * reviewer's name, no sidebar and no link into the app (reviewers are not portal users). Like PublicWatchShell, wider:
 * the review is a list of rows with a decision each.
 */
export default function PublicReviewShell({ tenantName = '', reviewerName = '', children }) {
  useEffect(() => { ensureNoReferrer(document); }, []);
  return (
    <div className="flex min-h-screen flex-col bg-ipc-surface">
      <header className="on-dark bg-ipc-primary text-white shadow-md">
        <div className="mx-auto flex h-14 max-w-5xl items-center gap-3 px-4">
          <ExternalLink href={BRAND.siteUrl} className="shrink-0 rounded">
            <BrandLogo tone="light" className="h-6 w-auto sm:h-7" />
          </ExternalLink>
          <span aria-hidden="true" className="h-6 w-px shrink-0 bg-white/30" />
          <span className="flex min-w-0 items-center gap-2 text-sm font-semibold tracking-tight sm:text-base">
            <ProductMark tone="light" size={28} />
            <span className="truncate">{PRODUCT_NAME}</span>
          </span>
          {tenantName ? <span className="hidden min-w-0 truncate text-sm text-white/90 sm:inline" data-testid="review-tenant">{tenantName}</span> : null}
          {reviewerName ? <span className="ml-auto min-w-0 truncate text-sm font-semibold" data-testid="review-reviewer">{reviewerName}</span> : null}
        </div>
        <HeaderAccent />
      </header>
      <main className="flex-1">
        <div className="mx-auto max-w-5xl space-y-5 px-4 py-8">{children}</div>
      </main>
      <BrandFooter securityLink={false} />
    </div>
  );
}
